
  import { LIFE_INSURANCE_PLAN_FEATURES } from '~/constants/insurance';

  export default {
    computed: {
      features () {
        return LIFE_INSURANCE_PLAN_FEATURES.map(f => {
          const planFeature = this.plan[f];
          if (!planFeature) return null;
          return planFeature ? { title: this.$t(`benefits.${this.benefitKey(f)}`), text: this.plan[`${f}_text`] } : null;
        }).filter(f => f);
      },
      plan () {
        return this.$store.getters['products/get'];
      },
      search () {
        return this.$store.getters['search/get'];
      }
    },
    methods: {
      benefitKey (feature) {
        if (feature === 'childrens_life_cover') {
          if (this.plan.cover_type === 'SI') {
            return `${feature}_si`;
          }
          if (this.plan.institution.slug === 'zurich-life') {
            return `${feature}_zurich_life`;
          }
        }
        return feature;
      }
    }
  };
